require('./_typed-array')('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.typed.int8-array.js
 ** module id = 497
 ** module chunks = 0
 **/